import { CONSTANTS } from '@/utils';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { CgDanger } from 'react-icons/cg';
import { FaRegCircleCheck } from 'react-icons/fa6';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { HiLockClosed, HiPlay } from 'react-icons/hi';
import { useSelector } from 'react-redux';

const CourseTopicListItem = ({ title, resources, activeResource, open, onChangeActiveResource }) => {
  const isLoggedIn = useSelector((state) => state.auth.loggedIn);

  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const totalVideo = resources.filter(
    (resource) =>
      resource.resource_type === CONSTANTS.LEARNING_RESOURCE_TYPE.VIDEO ||
      resource.resource_type === CONSTANTS.LEARNING_RESOURCE_TYPE.YOUTUBE
  ).length;
  const totalAudio = resources.filter(
    (resource) => resource.resource_type === CONSTANTS.LEARNING_RESOURCE_TYPE.AUDIO
  ).length;
  const totalPdf = resources.filter(
    (resource) => resource.resource_type === CONSTANTS.LEARNING_RESOURCE_TYPE.PDF
  ).length;
  const totalQuiz = resources.filter(
    (resource) => resource.resource_type === CONSTANTS.LEARNING_RESOURCE_TYPE.QUIZ
  ).length;

  return (
    <div className="p-4 bg-primary-100" style={{ borderRadius: 30 }}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between w-full space-x-3 text-left border-b cursor-pointer text-primary-700"
      >
        <div>
          <div className="font-bold leading-relaxed line-clamp-2">{title}</div>
          <div className="text-xs font-medium leading-relaxed line-clamp-2">
            {totalVideo > 0 && <span className="mr-2">{totalVideo} Video</span>}
            {totalAudio > 0 && <span className="mr-2">{totalAudio} Audio</span>}
            {totalPdf > 0 && <span className="mr-2">{totalPdf} PDF</span>}
            {totalQuiz > 0 && <span className="mr-2">{totalQuiz} Quiz</span>}
          </div>
        </div>
        <span>
          {isOpen && <FiChevronUp size={20} />}
          {!isOpen && <FiChevronDown size={20} />}
        </span>
      </button>

      {isOpen && (
        <div className="mt-4 space-y-4">
          {resources?.length === 0 && (
            <div className="flex items-center justify-center h-full p-6 space-x-3 text-sm text-center text-gray-400 border-b">
              <CgDanger size={18} />
              <span>No Resource Found</span>
            </div>
          )}

          {resources?.length > 0 &&
            resources.map((resource) => (
              <button
                key={resource.uuid}
                type="button"
                className={classNames('w-full gap-3 flex items-center px-4 py-3 rounded-full', {
                  'cursor-auto': resource.locked,
                  'cursor-pointer': !resource.locked,
                  'bg-primary-700 text-white': activeResource && activeResource.uuid === resource.uuid,
                  'bg-white text-primary-700 hover:bg-gray-100':
                    activeResource && activeResource.uuid !== resource.uuid && !resource.locked,
                  'text-gray-400 bg-gray-100':
                    activeResource && activeResource.uuid !== resource.uuid && resource.locked,
                })}
                disabled={resource.locked}
                onClick={() => onChangeActiveResource(resource)}
              >
                <div className="flex items-center justify-center w-8">
                  {resource.locked && <HiLockClosed size={20} />}
                  {!resource.locked && <HiPlay size={28} />}
                </div>

                <div className="flex-1 space-y-1">
                  <div className="text-sm font-semibold text-left">{resource.title}</div>
                </div>

                {resource.completed && (
                  <div className="text-right">
                    <FaRegCircleCheck
                      size={22}
                      className={
                        activeResource && activeResource.uuid === resource.uuid
                          ? 'text-primary'
                          : resource.completed
                            ? 'text-secondary-500'
                            : 'text-primary'
                      }
                    />
                  </div>
                )}
              </button>
            ))}
        </div>
      )}
    </div>
  );
};

CourseTopicListItem.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool,
};

CourseTopicListItem.defaultProps = {
  open: false,
};

export default CourseTopicListItem;
